import { gql } from 'graphql.macro';

export const oauthAppFieldsFragment = gql`
    fragment oauthAppFields on OAuthApp {
        _id
        name
        vendorName
        clientId
        confidential
        redirectUris
        allowedScopes
        allowedOrganizations
        allowClientCredentials
        status
        createdBy
        createdAt
        updatedAt
    }
`;
